<h1 mat-dialog-title [kitText]="titleText"></h1>
<div mat-dialog-content>
  <span [kitText]="replacementText"></span>
  <app-project-auto-complete-input [model]="projectAutoComplete"></app-project-auto-complete-input>
</div>
<div mat-dialog-actions>
  <kit-bs-button [kitModel]="deleteAction"></kit-bs-button>
  <kit-bs-button [kitModel]="cancelAction"></kit-bs-button>
</div>
